import { render, staticRenderFns } from "./MlMenu.vue?vue&type=template&id=3fdd03a0&scoped=true&"
import script from "./MlMenu.vue?vue&type=script&lang=js&"
export * from "./MlMenu.vue?vue&type=script&lang=js&"
import style0 from "./MlMenu.vue?vue&type=style&index=0&id=3fdd03a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd03a0",
  null
  
)

export default component.exports